import {Reducers} from './dataEnum';

/**
 * @deprecated redundant between {@link INIT_VALUE} and {@link UPDATE_ALL_VALUE}
 */
export const INIT_VALUE = `${Reducers.SETUP_STORE}/INIT_VALUE`;

export const RUN_PROTEIN_CONCENTRATOR = `${Reducers.SETUP_STORE}/RUN_PROTEIN_CONCENTRATOR`;

export const STOP_PROTEIN_CONCENTRATOR = `${Reducers.SETUP_STORE}/STOP_PROTEIN_CONCENTRATOR`;
export const PAUSE_PROTEIN_CONCENTRATOR = `${Reducers.SETUP_STORE}/PAUSE_PROTEIN_CONCENTRATOR`;

export const UPDATE_DIAPHRAGM_VACUUM_PRESSURE = `${Reducers.SETUP_STORE}/UPDATE_DIAPHRAGM_VACUUM_PRESSURE`;
export const UPDATE_DIAPHRAGM_PRESSURE = `${Reducers.SETUP_STORE}/UPDATE_DIAPHRAGM_PRESSURE`;
export const UPDATE_DIAPHRAGM_TIMING = `${Reducers.SETUP_STORE}/UPDATE_DIAPHRAGM_TIMING`;
export const UPDATE_VALVE_TIMING = `${Reducers.SETUP_STORE}/UPDATE_VALVE_TIMING`;
export const UPDATE_SHOW_WARNING = `${Reducers.SETUP_STORE}/UPDATE_SHOW_WARNING`;
export const AUTO_CALIBRATE = `${Reducers.SETUP_STORE}/AUTO_CALIBRATE`;
export const RESET_TO_DEFAULT = `${Reducers.SETUP_STORE}/RESET_TO_DEFAULT`;
export const CHECK_PROFILE_PARAM = `${Reducers.SETUP_STORE}/CHECK_PROFILE_PARAM`;
export const SAVE_DEVICE_VERSION = `${Reducers.SETUP_STORE}/SAVE_DEVICE_VERSION`;
export const SET_INVALID_AUTO_PROFILE_PARAMS = `${Reducers.SETUP_STORE}/SET_INVALID_AUTO_PROFILE_PARAMS`;

// Advanced Setup Page
export const UPDATE_PC_STATE = `${Reducers.SETUP_STORE}/UPDATE_PC_STATE`;

// status progress Bar
export const UPDATE_PERCENTAGE_PROGRESS_BAR = `${Reducers.SETUP_STORE}/UPDATE_PROGRESS_BAR`;
export const UPDATE_ESTIMATE_TIME = `${Reducers.SETUP_STORE}/UPDATE_ESTIMATE_TIME_REMAINING`;
export const UPDATE_PROGRESSBAR_STATUS = `${Reducers.SETUP_STORE}/UPDATE_PROGRESSBAR_STATUS`;
export const UPDATE_DEFAULT_CONFIG_PARAMS = `${Reducers.SETUP_STORE}/UPDATE_DEFAULT_CONFIG_PARAMS`;
export const UPDATE_DEFAULT_CONFIG_ADV_SETUP_PARAMS = `${Reducers.SETUP_STORE}/UPDATE_DEFAULT_CONFIG_ADV_SETUP_PARAMS`;
export const UPDATE_DEFAULT_RETURN_VALVE_PRESSURE_PARAMS = `${Reducers.SETUP_STORE}/UPDATE_DEFAULT_RETURN_VALVE_PRESSURE_PARAMS`;

// status
export const UPDATE_STATUS = `${Reducers.SETUP_STORE}/UPDATE_STATUS`;
export const UPDATE_STOPPING_FROM_BUTTON = `${Reducers.SETUP_STORE}/UPDATE_STOPPING_FROM_BUTTON`;
export const UPDATE_ACTIVE_MENU = `${Reducers.SETUP_STORE}/UPDATE_ACTIVE_MENU`;

// refill buffer
export const UPDATE_REFILL_BUFFER_VOLUME = `${Reducers.SETUP_STORE}/UPDATE_REFILL_BUFFER_VOLUME`;
export const IS_UPDATE_SESOR_REFILL_BUFFER = `${Reducers.SETUP_STORE}/IS_UPDATE_SESOR_REFILL_BUFFER`;

// EXPLORER PAGE
export const UPDATE_PROFILE_NAME = `${Reducers.SETUP_STORE}/UPDATE_PROFILE_NAME`;
export const UPDATE_PROFILE_LIST = `${Reducers.SETUP_STORE}/UPDATE_PROFILE_LIST`;
export const PROFILE_SELECTED = `${Reducers.SETUP_STORE}/PROFILE_SELECTED`;
export const PROFILE_SETTING_EXPLORER = `${Reducers.SETUP_STORE}/PROFILE_SETTING_EXPLORER`;
/**
 * @deprecated redundant between {@link INIT_VALUE} and {@link UPDATE_ALL_VALUE}
 */
export const UPDATE_ALL_VALUE = `${Reducers.SETUP_STORE}/UPDATE_ALL_VALUE`;
export const UPDATE_SHOW_PROFILE = `${Reducers.SETUP_STORE}/UPDATE_SHOW_PROFILE`;
export const UPDATE_LAST_PROFILE_ID_VIEW = `${Reducers.SETUP_STORE}/UPDATE_LAST_PROFILE_ID_VIEW`;
export const SET_PROFILE_LIST = `${Reducers.SETUP_STORE}/SET_PROFILE_LIST`;
export const RESET_PREVIEW_PROFILE = `${Reducers.SETUP_STORE}/RESET_PREVIEW_PROFILE`;
export const SAVE_PROFILE = `${Reducers.SETUP_STORE}/SAVE_PROFILE`;
export const UPDATE_CURRENT_PROFILE_PARAM = `${Reducers.SETUP_STORE}/UPDATE_CURRENT_PROFILE_PARAM`;
export const TEMPLATE_NEW_PROFILE = `${Reducers.SETUP_STORE}/TEMPLATE_NEW_PROFILE`;

// Auto Profile
export const COMPLETE_PROFILE_FILL = `${Reducers.SETUP_STORE}/COMPLETE_PROFILE_FILL`;
// export const SHOW_RECOVERY_LOADING = Reducers.SETUP_STORE+"/SHOW_RECOVERY_LOADING";
export const UPDATE_RECOVERY_STATUS = `${Reducers.SETUP_STORE}/UPDATE_RECOVERY_STATUS`;
export const IS_FINISH_RECOVERY = `${Reducers.SETUP_STORE}/IS_FINISH_RECOVERY`;
export const UPDATE_AUTO_PROFILE_SETUP_MODE = `${Reducers.SETUP_STORE}/UPDATE_AUTO_PROFILE_SETUP_MODE`;
export const UPDATE_AUTO_PROFILE_DIAFILTRATION_MODE = `${Reducers.SETUP_STORE}/UPDATE_AUTO_PROFILE_DIAFILTRATION_MODE`;

// Manual Profile
export const UPDATE_IS_MANUAL_PROFILE_RUNNING = `${Reducers.SETUP_STORE}/UPDATE_IS_MANUAL_PROFILE_RUNNING`;
export const UPDATE_IS_MANUAL_PROFILE_PAUSED = `${Reducers.SETUP_STORE}/UPDATE_IS_MANUAL_PROFILE_PAUSED`;

export const UPDATE_DIAFILTRATION_STATUS = `${Reducers.SETUP_STORE}/UPDATE_DIAFILTRATION_STATUS`;
export const UPDATE_SHOW_REFILL_BUFFER = `${Reducers.SETUP_STORE}/UPDATE_SHOW_REFILL_BUFFER`;

export const UPDATE_SHOW_THRESHOLD_ERROR = `${Reducers.SETUP_STORE}/UPDATE_SHOW_THRESHOLD_ERROR`;

// alert
export const SHOW_ALERT = `${Reducers.SETUP_STORE}/SHOW_ALERT`;

// export const SHOW_LOADING = Reducers.SETUP_STORE+"/SHOW_LOADING";
// export const UPDATE_LOADING = Reducers.SETUP_STORE+"/UPDATE_LOADING";

// save config
export const SAVE_CYCLE_THRESHOLD = `${Reducers.SETUP_STORE}/SAVE_CYCLE_THRESHOLD`;

// top menu
export const DISABLE_SAVE_BUTTON = `${Reducers.SETUP_STORE}/DISABLE_SAVE_BUTTON`;
export const BACK_BUTTON_PROPERTIES = `${Reducers.SETUP_STORE}/BACK_BUTTON_PROPERTIES`;
export const TOP_BUTTON_PROPERTIES = `${Reducers.SETUP_STORE}/TOP_BUTTON_PROPERTIES`;
export const TOP_BUTTON_SECONDARY_PROPERTIES = `${Reducers.SETUP_STORE}/TOP_BUTTON_SECONDARY_PROPERTIES`;
export const TOP_BUTTON_TERTIARY_PROPERTIES = `${Reducers.SETUP_STORE}/TOP_BUTTON_TERTIARY_PROPERTIES`;
export const UPDATE_LOCK_ACESS = `${Reducers.SETUP_STORE}/UPDATE_LOCK_ACESS`;
export const MODIFY_PROFILE = `${Reducers.SETUP_STORE}/MODIFY_PROFILE`;
export const MODIFY_ADV_SETUP = `${Reducers.SETUP_STORE}/MODIFY_ADV_SETUP`;
export const SET_TITLE_MENU_PROPERTIES = `${Reducers.SETUP_STORE}/SET_TITLE_MENU_PROPERTIES`;
export const SET_TOP_MENU_PROPERTIES = `${Reducers.SETUP_STORE}/SET_TOP_MENU_PROPERTIES`;
export const SET_DOUBLE_TOP_MENU_PROPERTIES = `${Reducers.SETUP_STORE}/SET_DOUBLE_TOP_MENU_PROPERTIES`;
export const SET_DISABLED_TOP_BUTTON_PROPERTIES = `${Reducers.SETUP_STORE}/SET_DISABLED_TOP_BUTTON_PROPERTIES`;

// info and support
export const UPDATE_FONT_SIZE = `${Reducers.SETUP_STORE}/UPDATE_FONT_SIZE`;

// usbfile update
/**
 * @deprecated
 */
export const IS_OPEN_FILE = `${Reducers.SETUP_STORE}/IS_OPEN_FILE`;
export const USB_PROPERTIES = `${Reducers.SETUP_STORE}/USB_PROPERTIES`;
export const USB_OPEN_FOR = `${Reducers.SETUP_STORE}/USB_OPEN_FOR`;
export const SELECTED_FILE_UPDATE = `${Reducers.SETUP_STORE}/SELECTED_FILE_UPDATE`;
export const SELECTED_FILE_EXPORT = `${Reducers.SETUP_STORE}/SELECTED_FILE_EXPORT`;
export const SELECTED_DATE_BEGIN_EXPORT = `${Reducers.SETUP_STORE}/SELECTED_DATE_BEGIN_EXPORT`;
export const SELECTED_DATE_END_EXPORT = `${Reducers.SETUP_STORE}/SELECTED_DATE_END_EXPORT`;
export const SELECTED_FOLDER_EXPORT_DESTINATION = `${Reducers.SETUP_STORE}/SELECTED_FOLDER_EXPORT_DESTINATION`;
export const EXPAND_ACCORDION_STATUS = `${Reducers.SETUP_STORE}/EXPAND_ACCORDION_STATUS`;

// wizard component
export const NEXT_ACTION_WIZARD = `${Reducers.SETUP_STORE}/NEXT_ACTION_WIZARD`;
export const PREV_ACTION_WIZARD = `${Reducers.SETUP_STORE}/PREV_ACTION_WIZARD`;
// cleaning wizard
export const SET_CLEANING_PROPERTIES = `${Reducers.SETUP_STORE}/SET_CLEANING_PROPERTIES`;

// Adv Setup Explorer
export const UPDATE_ADV_SETUP_NAME = `${Reducers.SETUP_STORE}/UPDATE_ADV_SETUP_NAME`;
export const UPDATE_ADV_SETUP_LIST = `${Reducers.SETUP_STORE}/UPDATE_ADV_SETUP_LIST`;
export const ADV_SETUP_SELECTED = `${Reducers.SETUP_STORE}/ADV_SETUP_SELECTED`;
export const ADV_SETUP_SETTING_EXPLORER = `${Reducers.SETUP_STORE}/ADV_SETUP_SETTING_EXPLORER`;
export const UPDATE_ALL_VALUE_ADV_SETUP = `${Reducers.SETUP_STORE}/UPDATE_ALL_VALUE_ADV_SETUP`;
export const UPDATE_SHOW_ADV_SETUP = `${Reducers.SETUP_STORE}/UPDATE_SHOW_ADV_SETUP`;
export const UPDATE_LAST_ADV_SETUP_ID_VIEW = `${Reducers.SETUP_STORE}/UPDATE_LAST_ADV_SETUP_ID_VIEW`;
export const UPDATE_LAST_ADV_SETUP_ID_CREATED = `${Reducers.SETUP_STORE}/UPDATE_LAST_ADV_SETUP_ID_CREATED`;
export const SET_ADV_SETUP_LIST = `${Reducers.SETUP_STORE}/SET_ADV_SETUP_LIST`;
export const RESET_PREVIEW_ADV_SETUP = `${Reducers.SETUP_STORE}/RESET_PREVIEW_ADV_SETUP`;
export const SAVE_ADV_SETUP = `${Reducers.SETUP_STORE}/SAVE_ADV_SETUP`;
export const SET_BUTTON_TYPE_ADV = `${Reducers.SETUP_STORE}/SET_BUTTON_TYPE_ADV`;
export const UPDATE_CURRENT_ADV_SETUP_PARAM = `${Reducers.SETUP_STORE}/UPDATE_CURRENT_ADV_SETUP_PARAM`;
export const TEMPLATE_NEW_ADV_SETUP = `${Reducers.SETUP_STORE}/TEMPLATE_NEW_ADV_SETUP`;
export const EDIT_ADV_SETUP = `${Reducers.SETUP_STORE}/EDIT_ADV_SETUP`;
export const DISABLE_SAVE_SETUP_BUTTON = `${Reducers.SETUP_STORE}/DISABLE_SAVE_SETUP_BUTTON`;
export const UPDATE_MESSAGE_AUTO_PROFILE_HELP = `${Reducers.SETUP_STORE}/UPDATE_MESSAGE_AUTO_PROFILE_HELP`;
export const UPDATE_DEFAULT_HIGH_PRESSURE_PARAM = `${Reducers.SETUP_STORE}/UPDATE_DEFAULT_HIGH_PRESSURE_PARAM`;
export const UPDATE_DEFAULT_LOW_PRESSURE_PARAM = `${Reducers.SETUP_STORE}/UPDATE_DEFAULT_LOW_PRESSURE_PARAM`;
export const UPDATE_DEFAULT_HIGH_SEQUENCE_PARAM = `${Reducers.SETUP_STORE}/UPDATE_DEFAULT_HIGH_SEQUENCE_PARAM`;
export const UPDATE_DEFAULT_LOW_SEQUENCE_PARAM = `${Reducers.SETUP_STORE}/UPDATE_DEFAULT_LOW_SEQUENCE_PARAM`;
export const UPDATE_DEFAULT_PRESSURE_TEMPLATE = `${Reducers.SETUP_STORE}/UPDATE_DEFAULT_PRESSURE_TEMPLATE`;
export const UPDATE_DEFAULT_SEQUENCE_TEMPLATE = `${Reducers.SETUP_STORE}/UPDATE_DEFAULT_SEQUENCE_TEMPLATE`;
export const UPDATE_CURRENT_IS_MORE_THAN_50_ML = `${Reducers.SETUP_STORE}/UPDATE_CURRENT_IS_MORE_THAN_50_ML`;

// wifi
/**
 * @deprecated current state of wifi status will be handled by the derived context
 */
export const UPDATE_WIFI_STATUS = `${Reducers.SETUP_STORE}/UPDATE_WIFI_STATUS`;
/**
 * @deprecated current state of wifi list will be handled by the derived context
 */
export const UPDATE_WIFI_LIST = `${Reducers.SETUP_STORE}/UPDATE_WIFI_LIST`;
/**
 * @deprecated current state of connected wifi will be handled by the derived context
 */
export const SET_CURRENT_WIFI_CONNECTED = `${Reducers.SETUP_STORE}/SET_CURRENT_WIFI_CONNECTED`;
/**
 * @deprecated current state of connected wifi will be handled by the derived context
 */
export const UPDATE_WIFI = `${Reducers.SETUP_STORE}/UPDATE_WIFI`;
/**
 * @deprecated the reducer has been moved into deviceStore
 */
export const IS_SHUTTINGDOWN = `${Reducers.SETUP_STORE}/IS_SHUTTINGDOWN`;
export const ERROR_PARAMS = `${Reducers.SETUP_STORE}/ERROR_PARAMS`;
export const CYCLE_FINISH = `${Reducers.SETUP_STORE}/CYCLE_FINISH`;

/**
 * @enum {String}
 */
export const CUSTOM_OPERATION = {
  SET: `${Reducers.SETUP_STORE}/SET_CUSTOM_OPERATION`,
  OPERATION_LIST: `${Reducers.SETUP_STORE}/CUSTOM_OPERATION_LIST`,
  TEMP_OPERATION_LIST: `${Reducers.SETUP_STORE}/CUSTOM_OPERATION_TEMP_LIST`,
  NAME: `${Reducers.SETUP_STORE}/CUSTOM_OPERATION_NAME`,
  FILE_NAME: `${Reducers.SETUP_STORE}/CUSTOM_OPERATION_FILE_NAME`,
  CONTENT_CHANGED: `${Reducers.SETUP_STORE}/CUSTOM_OPERATION_CONTENT_CHANGED`,
  IS_DEPRESSURIZED_AT_THE_END: `${Reducers.SETUP_STORE}/CUSTOM_OPRATION_IS_DEPRESSURIZED_AT_THE_END`,
  REPEAT: `${Reducers.SETUP_STORE}/CUSTOM_OPERATION_REPEAT`,
  REPEATED: `${Reducers.SETUP_STORE}/CUSTOM_OPERATION_REPEATED`,
  DEFAULT_PRIME_PARAM: `${Reducers.SETUP_STORE}/CUSTOM_OPERATION_DEFAULT_PRIME_PARAM`,
  STATUS: `${Reducers.SETUP_STORE}/CUSTOM_OPERATION_STATUS`,
  MESSAGE: `${Reducers.SETUP_STORE}/CUSTOM_OPERATION_MESSAGE`,
  TIME_ELAPSED: `${Reducers.SETUP_STORE}/CUSTOM_OPERATION_TIME_ELAPSED`,
  PRELOADED: `${Reducers.SETUP_STORE}/CUSTOM_OPERATION_PRELOADED`,
};

/**
 * @enum {String}
 */
export const CLEANING_CUSTOM_OPERATION = {
  SET: `${Reducers.SETUP_STORE}/SET_CLEANING_CUSTOM_OPERATION`,
  OPERATION_LIST: `${Reducers.SETUP_STORE}/CLEANING_CUSTOM_OPERATION_LIST`,
  TEMP_OPERATION_LIST: `${Reducers.SETUP_STORE}/CLEANING_CUSTOM_OPERATION_TEMP_LIST`,
  NAME: `${Reducers.SETUP_STORE}/CLEANING_CUSTOM_OPERATION_NAME`,
  IS_DEPRESSURIZED_AT_THE_END: `${Reducers.SETUP_STORE}/CLEANING_CUSTOM_OPRATION_IS_DEPRESSURIZED_AT_THE_END`,
  REPEAT: `${Reducers.SETUP_STORE}/CLEANING_CUSTOM_OPERATION_REPEAT`,
  REPEATED: `${Reducers.SETUP_STORE}/CLEANING_CUSTOM_OPERATION_REPEATED`,
  DEFAULT_PRIME_PARAM: `${Reducers.SETUP_STORE}/CLEANING_CUSTOM_OPERATION_DEFAULT_PRIME_PARAM`,
  STATUS: `${Reducers.SETUP_STORE}/CLEANING_CUSTOM_OPERATION_STATUS`,
  MESSAGE: `${Reducers.SETUP_STORE}/CLEANING_CUSTOM_OPERATION_MESSAGE`,
  TIME_ELAPSED: `${Reducers.SETUP_STORE}/CLEANING_CUSTOM_OPERATION_TIME_ELAPSED`,
};

export const IS_STOP_FROM_PROFILE = `${Reducers.SETUP_STORE}/IS_STOP_FROM_PROFILE`;
export const IS_RECOVERY_CLICKED = `${Reducers.SETUP_STORE}/IS_RECOVERY_CLICKED`;
export const IS_RECALIBRATION = `${Reducers.SETUP_STORE}/IS_RECALIBRATION`;
export const IS_RECOVERY_FROM_ERROR_PROFILE = `${Reducers.SETUP_STORE}/IS_RECOVERY_FROM_ERROR_PROFILE`;
export const SET_PROFILE_RUNNING = `${Reducers.SETUP_STORE}/SET_PROFILE_RUNNING`;
export const SET_CURRENT_BUFFER = `${Reducers.SETUP_STORE}/SET_CURRENT_BUFFER`;
export const SET_CURRENT_VOLUME = `${Reducers.SETUP_STORE}/SET_CURRENT_VOLUME`;
export const SET_REQUIRE_REFILL = `${Reducers.SETUP_STORE}/SET_REQUIRE_REFILL`;
